import { render, staticRenderFns } from "./MainAction.vue?vue&type=template&id=4477d71f&scoped=true"
import script from "./MainAction.vue?vue&type=script&lang=js"
export * from "./MainAction.vue?vue&type=script&lang=js"
import style0 from "./MainAction.vue?vue&type=style&index=0&id=4477d71f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4477d71f",
  null
  
)

export default component.exports